export default __webpack_public_path__ + "logo15cbdfa2.png";